module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@3x-6fb665a043ecb97e6c3e8c037db3541c.png";